import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';

let appInsights = null;
let initialized = false;

function toError(value, fallbackMessage) {
  if (value instanceof Error) {
    return value;
  }

  if (typeof value === 'string') {
    return new Error(value);
  }

  return new Error(fallbackMessage);
}

export function initializeApplicationInsights(router) {
  if (initialized) {
    return appInsights;
  }

  initialized = true;

  const connectionString =
    import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING?.trim();
  if (!connectionString) {
    if (import.meta.env.DEV) {
      console.info(
        '[appinsights] VITE_APPINSIGHTS_CONNECTION_STRING is missing. Telemetry is disabled.',
      );
    }
    return null;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      samplingPercentage: Number(
        import.meta.env.VITE_APPINSIGHTS_SAMPLING_PERCENTAGE || '50',
      ),
      enableAutoRouteTracking: false,
      enableUnhandledPromiseRejectionTracking: true,
      disableAjaxTracking: false,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      autoTrackPageVisitTime: false,
    },
  });

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer((item) => {
    const baseType = item.baseType;
    const baseData = item.baseData;

    if (baseType === 'ExceptionData') {
      return;
    }

    if (baseType === 'RemoteDependencyData' && baseData?.success === false) {
      return;
    }

    return false;
  });

  router.afterEach(() => {
    // Keep hook for future route-specific failure markers while suppressing page-view volume.
  });

  window.addEventListener('error', (event) => {
    appInsights?.trackException({
      exception: toError(event.error, event.message || 'window.error'),
      severityLevel: SeverityLevel.Error,
      properties: {
        source: 'window.error',
        filename: event.filename,
        lineno: String(event.lineno),
        colno: String(event.colno),
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    appInsights?.trackException({
      exception: toError(event.reason, 'unhandledrejection'),
      severityLevel: SeverityLevel.Error,
      properties: {
        source: 'window.unhandledrejection',
      },
    });
  });

  return appInsights;
}
